import {CurrencyService} from '../../services/CurrencyService';
import {favorites} from '../../services/arsweb/RoutingPaths';

import {CONSOLIDATION_CURRENCY}  from '../../components/tables/accounts/accountsView.directive';
import accountInfoPanelTemplate from './accountInfoPanel.html';

/** @ngInject */
export function accountInfoPanel() {
    return {
        restrict: 'E',
        templateUrl: accountInfoPanelTemplate,
        link: function($scope, element, attrs, ctrl) {
            ctrl.parentController = $scope.vm;
            ctrl.parentController.$scope.detailPromise.then(() => ctrl.loadCurrencyDep());
        },
        controller: AccountInfoPanelController,
        controllerAs: 'panelController'
    };
}

class AccountInfoPanelController {
    constructor($scope, userService) {
        this.userService = userService;
        this.$scope = $scope;
        this.$scope.pickedDate = this.$scope.pickedDate || new Date();
        this.ftsMainDependencies = this.userService.fsMainDependencies;
        this.sessionPersistance = this.ftsMainDependencies.sessionPersistance;
        this.isProcessing = false;
        this.filterFormatter = userService.filterFormatter;
    }

    loadCurrencyDep() {
        return new CurrencyService(this.ftsMainDependencies).getCurrencies().then((data)=> {
            // Currencies for consolidating in a currency list
            this.mainCurrencies = data;
            this.currencyNameByCode = data.reduce((map, ccy) => {
                map[ccy.code] = ccy.name;
                return map} , []);

            // Check account has been loaded
            if(this.$scope.accountInfo) {
                this.$scope.accountInfo.currencyName = this.currencyNameByCode[this.$scope.accountInfo.currencyCode];
                this.userService.promise.then(() => this.recalculateBalances());
            }
        });
    }

    selectConsolidationCurrency(currency) {
        this.sessionPersistance.set(CONSOLIDATION_CURRENCY, currency);
        this.$scope.consolitationcurrency = currency;
        this.parentController.$scope.consolitationcurrency = currency;
        this.accountInfoReload();
    }

    selectBalanceDate(pickedDate) {
        this.$scope.pickedDate = pickedDate;
        this.accountInfoReload();
    }

    accountInfoReload() {
        this.parentController.loadAccount(this.$scope.pickedDate).then(() => this.recalculateBalances());
    }

    recalculateBalances() {
        this.balance = this.filterFormatter('fsNumber')(this.$scope.accountInfo.balance.amount,
            this.$scope.accountInfo.balance.fractionDigits);
        this.amount = this.filterFormatter('fsNumber')(this.$scope.accountInfo.consolidatedBalance.amount,
            this.$scope.accountInfo.consolidatedBalance.fractionDigits);
    }

    updateFavorite() {
        this.isProcessing = true;
        const accountInfo = this.parentController.$scope.accountInfo;
        const accountID = accountInfo.accountName;
        const promise = accountInfo.favorite ? this.parentController.accountService.postUserData(favorites, accountID) :
            this.parentController.accountService.putUserData(favorites, accountID);
        promise.then(() => this.favoritesUpdated(accountInfo, !accountInfo.favorite));
    }

    favoritesUpdated(accountInfo, fav) {
        accountInfo.favorite = fav;
        this.isProcessing = false;
    }
}
